@if (currentTypes.length !== 0) {
  <h3 class="title-divider">{{ "CodeNachRechtart" | translate }}</h3>
  <input
    (selectItem)="onSelected($event)"
    [(ngModel)]="value"
    [disabled]="disabled"
    [inputFormatter]="inputFormatter"
    [ngbTypeahead]="search"
    [resultFormatter]="resultFormatter"
    class="form-control form-control-component mt-2"
    type="search" />
  @if (showNoResultText) {
    <div class="dropdown-menu show">
      <button (click)="onClear()" [disabled]="disabled" class="dropdown-item">{{ "search.noResults" | translate }}</button>
    </div>
  }
  @if (codes.size > 0) {
    <div class="mt-2" style="max-height: 250px; overflow: auto">
      <table class="cap-table-detail">
        <thead>
          <tr>
            <th style="width: 100%">
              {{ "Art" | translate }}
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          @for (code of codes; track code; let i = $index) {
            <tr>
              <td class="noselect">
                {{ code.text | translateName }}
              </td>
              <td>
                <button
                  (click)="onDelete(code)"
                  [disabled]="disabled"
                  [ngbTooltip]="'AuftragLoeschen' | translate"
                  class="btn btn-danger btn-sm deleteButton"
                  placement="left"
                  type="button">
                  <i class="fas fa-trash"></i>
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
}
